const LOGIN_REQUEST = "LOGIN_REQUEST";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAILURE = "LOGIN_FAILURE";

export { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS };
